module.exports = __webpack_public_path__ + "cdf946ccbb3083c127c55806db7fcc39.pdf";